import API from '@/views/Fdc/Apis/'

export default {
  name: 'SpcRuleModal',
  props: {
    modalVisible: {
      type: Boolean,
      default: false
    },
    modalType: {
      type: String,
      default: ''
    },
    spcCodeList: {
      type: undefined,
      default: ''
    },
    initValue: {
    }
  },
  computed: {
  },
  watch: {
    /**
     * Modal의 Visible 여부 설정
     */
    modalVisible () {
      this.visible = this.modalVisible
    },
    /**
     * Modal의 Save Type 설정(Add/Edit)
     */
    modalType () {
      this.type = this.modalType
      this.modalTitle = this.type + ' SPC Rule'
    },
    /**
     * 공통 Code List를 이용한 ComboBox 설정
     */
    spcCodeList () {
      // this.codeList = this.spcCodeList

      this.compareOperList = this.spcCodeList.filter(data => data.codeType === 'COMPARE_OPERATION')
      this.compareLimitList = this.spcCodeList.filter(data => data.codeType === 'COMPARE_LIMIT')

      // 공통 코드 테이블에 없는 '(직접 입력)' 선택지 추가
      this.compareLimitList.push({
        codeDesc: 'DIRECT_INPUT',
        codeId: 'DIRECT_INPUT',
        codeName: '(직접 입력)',
        codeNameEng: '(Input)',
        codeType: 'COMPARE_LIMIT',
        dispolayOrder: 999,
        useYn: 'Y'
      })

      // compareOper 선택값에 따른 compareLimit Option disabled 설정을 위한 속성 추가
      this.compareLimitList.forEach(element => {
        element.isDisable = false
        element.style = 'color:#4a4a4a' // select option default color
      })

      // console.log('compareLimitList', this.compareLimitList)
    },
    /**
     * Modal 초기 정보 Setting
     */
    initValue () {
      // Edit 정보
      this.ruleNo = this.initValue.ruleNo
      this.ruleDesc = this.initValue.ruleDesc
      this.detectionCnt = this.initValue.detectionCount
      this.sampleCnt = this.initValue.sampleCount
      this.compareOperation = this.initValue.compareOperation
      this.compareLimit = this.initValue.compareLimit

      // Add 정보
      this.usedRuleNoList = this.initValue.usedRuleNoList
    },
    /**
     * Compare Limit ComboBox 선택값 확인
     */
    compareLimit () {
      // console.log('compareLimit watch')
      this.checkDirectInput()
    },
    /**
     * Compare Operation ComboBox 선택값 확인
     */
    compareOperation () {
      this.checkCompareSelect(this.compareOperation)
    }
  },
  methods: {
    /**
     * Compare Operation 선택값에 따라 Compare Limit Option들의 사용 여부를 설정합니다.
     * @param {String} codeId 선택한 Compare Operation Option의 Code Id
     */
    checkCompareSelect (codeId) {
      let enableList = []
      let disableList = []

      switch (codeId) {
        case 'GT':
        case 'LT':
          // ZONE을 제외한 모든 Option 사용 가능
          enableList = ['USL', 'LSL', 'UCL', 'LCL', 'CL', 'BEFORE', '+1SIGMA', '-1SIGMA', '+2SIGMA', '-2SIGMA', 'DIRECT_INPUT']
          disableList = ['ZONE_1SIGMA', 'ZONE_2SIGMA']
          break
        case 'CD':
          // BEFORE만 사용 가능
          enableList = ['BEFORE']
          disableList = ['USL', 'LSL', 'UCL', 'LCL', 'CL', '+1SIGMA', '-1SIGMA', '+2SIGMA', '-2SIGMA', 'ZONE_1SIGMA', 'ZONE_2SIGMA', 'DIRECT_INPUT']
          break
        case 'WITHIN':
        case 'NONWITHIN':
          // ZONE만 사용 가능
          enableList = ['ZONE_1SIGMA', 'ZONE_2SIGMA']
          disableList = ['USL', 'LSL', 'UCL', 'LCL', 'CL', 'BEFORE', '+1SIGMA', '-1SIGMA', '+2SIGMA', '-2SIGMA', 'DIRECT_INPUT']
          break
        default:
          enableList = ['USL', 'LSL', 'UCL', 'LCL', 'CL', 'BEFORE', '+1SIGMA', '-1SIGMA', '+2SIGMA', '-2SIGMA', 'ZONE_1SIGMA', 'ZONE_2SIGMA', 'DIRECT_INPUT']
          break
      }

      if (enableList && enableList.length > 0) {
        enableList.forEach(id => {
          this.setOption(id, true)
        })
      }

      if (disableList && disableList.length > 0) {
        disableList.forEach(id => {
          this.setOption(id, false)
        })

        // 선택 불가 Limit Option 선택중일 경우 초기화
        if (disableList.includes(this.compareLimit)) this.compareLimit = null
      }
    },
    /**
     * Compare Limit Option의 사용 여부와 css style을 설정합니다.
     * @param {String} codeId Compare Limit Option의 Code Id
     * @param {Boolean} isEnable 해당 Compare Limit Option 사용 여부
     */
    setOption (codeId, isEnable) {
      let option = this.compareLimitList.find(data => data.codeId === codeId)

      option.isDisable = !isEnable

      if (isEnable) {
        option.style = 'color:#4a4a4a' // select option default color
      } else {
        option.style = 'color:lightgray'
      }
    },
    /**
     * Compare Limit '직접 입력' 선택 여부에 따라 input disabled를 설정합니다.
     */
    checkDirectInput () {
      if (this.compareLimit === 'DIRECT_INPUT') {
        this.useDirectInput = true
        this.compareLimitInput = this.initValue.compareLimit === 'DIRECT_INPUT' ? this.initValue.limitCodeName : null
      } else {
        this.useDirectInput = false
        this.compareLimitInput = null
      }
    },
    /**
     * Modal을 닫고 초기화합니다.
     */
    resetModal () {
      this.resetRuleData()
      this.$emit('modal-visible')
    },
    /**
     * 각 정보를 초기화합니다.
     */
    resetRuleData () {
      this.ruleNo = null
      this.ruleDesc = null
      this.detectionCnt = null
      this.sampleCnt = null
      this.compareOperation = null
      this.compareLimit = null
      this.isDuplicate = ''
    },
    /**
     * User Custom Rule을 저장합니다.
     */
    async btnSaveClick () {
      if (!this.checkEmptyValue()) {
        return
      }

      let payload = [{
        ruleNo: this.ruleNo,
        ruleDesc: this.ruleDesc,
        customYn: 'Y',
        detectionCount: this.detectionCnt,
        sampleCount: this.sampleCnt,
        compareLimit: this.getLimitValue(),
        compareOperation: this.compareOperation,
        equalbreaksYn: 'N',
        oocresetYn: 'N',
        ruleFigures: '',

        createUser: 'brique',
        createDt: null,
        modifyUser: 'brique',
        modifyDt: null
      }]

      let self = this

      this.$dialog.confirm({
        message: this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE'),
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        conformText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function saveLastProcess (response) {
            if (response != null && response.status === 200) {
              // self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
              self.$dialog.alert({
                message: self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'),
                scroll: 'keep'
              })

              self.resetModal()
              self.$emit('close-and-refresh')
            } else {
              // self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
              self.$dialog.alert({
                message: self.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'),
                scroll: 'keep'
              })
            }
          }

          API.Model.saveSpcRule(payload).then(response => {
            saveLastProcess(response)
          })
        },
        oncancel: function () {},
        scroll: 'keep'
      })
    },
    /**
     * Compare Limit Input 값을 DB Table의 Rule에 맞게 변환합니다.
     * @returns {String} 변환된 문자열
     */
    getLimitValue () {
      if (this.compareLimit === 'DIRECT_INPUT') {
        return '{' + this.compareLimitInput + '}'
      } else {
        return this.compareLimit
      }
    },
    /**
     * Compare Limit Input 값을 Float로 변환합니다.
     */
    checkLimitValue () {
      // if (this.compareLimitInput && typeof this.compareLimitInput === 'string' && this.compareLimitInput.includes('.')) {
      //   let arr = this.compareLimitInput.split('.')
      //   let maxLength = (arr[0].length + 1 + 10) // 소수점 앞 + 소수점 + 소수점 뒤 제한(변경시 b-input step 값 함께 변경 필요)

      //   if (this.compareLimitInput.length > maxLength) {
      //     this.compareLimitInput = this.compareLimitInput.substr(0, maxLength)
      //   }
      // }

      if (this.compareLimitInput && this.compareLimitInput.length > 20) {
        this.compareLimitInput = this.compareLimitInput.substr(0, 20)
      }
      // console.log(isNaN(parseFloat(this.compareLimitInput)), parseFloat(this.compareLimitInput))
      this.compareLimitInput = isNaN(parseFloat(this.compareLimitInput)) ? null : parseFloat(this.compareLimitInput)
    },
    /**
     * 각 Input을 모두 입력/선택했는지 확인합니다.
     * @returns {Boolean} 입력/선택 완료 여부
     */
    checkEmptyValue () {
      if (this.ruleNo === undefined || !this.ruleNo) {
        this.$dialog.alert({
          message: 'Rule No를 입력하세요.',
          scroll: 'keep'
        })
        // this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Rule No'])) // INFORM_ITEM_NOT_ENTERED: '{0}을(를) 입력하세요.'
        return false
      } else if (this.isDuplicate) {
        this.$dialog.alert({
          message: 'Rule No 값이 중복되었습니다.',
          scroll: 'keep'
        })
        // this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['Rule No'])) // INFORM_KEY_DUPLICATED: '{0} 값이 중복되었습니다.'
        return false
      } else if (this.ruleDesc === undefined || !this.ruleDesc) {
        this.$dialog.alert({
          message: 'Rule Description을 입력하세요.',
          scroll: 'keep'
        })
        return false
      } else if (this.detectionCnt === undefined || !this.detectionCnt) {
        this.$dialog.alert({
          message: 'Detection Count를 입력하세요.',
          scroll: 'keep'
        })
        return false
      } else if (this.sampleCnt === undefined || !this.sampleCnt) {
        this.$dialog.alert({
          message: 'Sample Count를 입력하세요.',
          scroll: 'keep'
        })
        return false
      } else if (this.compareOperation === undefined || !this.compareOperation) {
        this.$dialog.alert({
          message: 'Compare Operation을 선택하세요.',
          scroll: 'keep'
        })
        return false
      } else if (this.compareLimit === undefined || !this.compareLimit) {
        this.$dialog.alert({
          message: 'Compare Limit을 선택하세요.',
          scroll: 'keep'
        })
        return false
      } else if (this.compareLimit === 'DIRECT_INPUT' && (this.compareLimitInput === undefined || !this.compareLimitInput)) {
        this.$dialog.alert({
          message: 'Compare Limit Value를 입력하세요.',
          scroll: 'keep'
        })
        return false
      }
      return true
    },
    /**
     * Rule No Input 값을 Int로 변환하고, 1~9999 범위에 맞춥니다.
     */
    checkRuleNo () {
      if (!this.ruleNo) return

      this.ruleNo = parseInt(this.ruleNo)

      if (this.ruleNo < 1) {
        this.ruleNo = null
      } else if (this.ruleNo > 9999) {
        this.ruleNo = 9999
      }

      this.checkDuplicateNo()
    },
    /**
     * Detection Count/Sample Count Input 값을 Int로 변환하고, 각 범위에 맞춥니다.
     */
    checkCount () {
      if (this.detectionCnt) {
        this.detectionCnt = parseInt(this.detectionCnt)

        if (this.detectionCnt < 1) {
          this.detectionCnt = 1
        } else if (this.detectionCnt > 15) {
          this.detectionCnt = 15
        }
      }

      if (this.sampleCnt) {
        this.sampleCnt = parseInt(this.sampleCnt)

        if (this.sampleCnt < 1) {
          this.sampleCnt = 1
        } else if (this.sampleCnt > 15) {
          this.sampleCnt = 15
        }
      }

      this.checkComparison()
    },
    /**
     * Detection Count 값과 Sample Count 값의 대소 여부를 비교하고 처리합니다.
     */
    checkComparison () {
      let min = !this.detectionCnt ? 1 : Number(this.detectionCnt)
      let sample = !this.sampleCnt ? 1 : Number(this.sampleCnt)
      // let min = (this.detectionCnt === null || this.detectionCnt === '') ? 1 : Number(this.detectionCnt)
      // let sample = (this.sampleCnt === null || this.sampleCnt === '') ? 1 : Number(this.sampleCnt)
      if (sample < min) {
        this.sampleCnt = null
      }
    },
    /**
     * Rule No Input 값이 기존 Rule과 중복되지 않는지 확인합니다.
     */
    checkDuplicateNo () {
      if (this.usedRuleNoList.includes(this.ruleNo)) {
        this.isDuplicate = true
      } else {
        this.isDuplicate = false
      }
    }
  },
  data () {
    return {
      visible: false,
      type: '',
      modalTitle: '',
      isDuplicate: '',
      duplicatedMsg: '이미 사용중인 번호입니다.',
      useDirectInput: false,
      usedRuleNoList: [],

      // rule row data
      ruleNo: null,
      ruleDesc: null,
      detectionCnt: null,
      sampleCnt: null,
      compareLimit: null,
      compareLimitInput: null,
      compareOperation: null,

      // code 목록 배열
      // codeList: [],
      compareLimitList: [],
      compareOperList: []
    }
  }
}
